<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-product-documents-wording-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-panel
          :column-defs="columnDefs"
          height="xl"
          :url="() => this.$api.productWording.list()"
          :auto-size="true"
          @rowClicked="edit"
          title="Wording"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'wording.create' })"
          >
            <feather-icon icon="UploadIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create New Wording</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import CellRendererVerified from "@/views/components/ag-grid/cell-renderer/CellRendererVerified";

export default {
  components: {
    TGrid,
    GridPanel,
    CellRendererVerified,
  },
  mixins: [CellMatchingMixin,CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      componentAccess: {
        canCreate: {
          route: 'wording.create',
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Friendly Name',
          field: 'FriendlyName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'File',
          field: 'FileName',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Risk Code',
          field: 'RiskCodeText',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Wording Code',
          field: 'WordingCode',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Insuring Clause',
          field: 'InsuringClause',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Is Signature Skip',
          field: 'IsSignatureSkip',
          filter: 'agTextColumnFilter',
          cellRenderer: 'CellRendererVerified',
        },
      ],
    }
  },
  methods: {
    edit({data}) {
      this.$router.push({ name: 'wording.edit', params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
